import { Text } from '../Text'
import { TextTypes } from '../../../types'
import React, { ReactElement, ReactNode } from 'react'

export interface GridCellProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
    title: ReactNode
    children: ReactNode
}

export const GridCell = ({ title, children, ...props }: GridCellProps): ReactElement => {
    return (
        <div className={`flex flex-col items-start ${props.className ?? ''}`}>
            <Text type={TextTypes.SMALL_TEXT} tag="h4">
                {title}
            </Text>
            {children}
        </div>
    )
}
